import { FDIntentTypes } from '../../../types/fd-ftux.types'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { postCTA } from '../../../utils/appBridge'
import Button from '../../ui-components/Button'
import RenderHTML from '../../ui-components/RenderHTML'
import { getInvestNowCTA, getFDDashboardCTA } from '../../../utils/FD/FTUX/fdFTUXConfig'
import { useMemo } from 'react'
import { getBottomPadding } from '../../../utils/sessionStorage'

const lastStepConfig: {
  [x in `${FDIntentTypes}`]: {
    label: string
    action: () => void
  }
} = {
  [FDIntentTypes.INVEST_NOW]: {
    label: 'Explore Plans',
    action: () => {
      postCTA(JSON.stringify(getInvestNowCTA(FDIntentTypes.INVEST_NOW)))
    }
  },
  [FDIntentTypes.CALLBACK]: {
    label: 'Go to dashboard',
    action: () => {
      postCTA(JSON.stringify(getFDDashboardCTA(FDIntentTypes.CALLBACK)))
    }
  },
  [FDIntentTypes.INVEST_LATER]: {
    label: 'Go to dashboard',
    action: () => {
      postCTA(JSON.stringify(getFDDashboardCTA(FDIntentTypes.INVEST_LATER)))
    }
  }
}

export const BottomBar = ({
  handleRightClick,
  isLastStep = false,
  selectedRadioBox,
  ScreenName,
  screenType
}: {
  handleRightClick: () => void
  isLastStep?: boolean
  selectedRadioBox: string | null
  ScreenName: string
  screenType: string
}) => {
  const configAction = useMemo(() => lastStepConfig?.[selectedRadioBox as `${FDIntentTypes}`], [selectedRadioBox])

  if (isLastStep) {
    return (
      <div style={{ paddingBottom: `calc(${getBottomPadding()}px + 20px)` }} className='px-5 pt-5 w-full'>
        <Button
          onClick={() => {
            trackEvent({
              eventName: EventNames.ButtonTap,
              payload: {
                buttonLabel: configAction?.label,
                eventId: selectedRadioBox ?? '',
                ScreenName,
                screenType
              }
            })
            setTimeout(() => {
              configAction?.action()
            }, 150)
          }}
          isFullWidth
          buttonClassName='w-full !h-[56px] !text-[#0E6FA5] !text-[16px]'
          label={configAction?.label}
        />
      </div>
    )
  }

  return (
    <div
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 40px)` }}
      className='px-5 pt-2 flex items-center justify-between animate-fade-550'
    >
      <div
        style={{ backdropFilter: 'blur(27px)' }}
        onClick={handleRightClick}
        className='border border-[#33A7E4] rounded-xl p-3 ml-auto'
      >
        <RenderHTML innerHTMLText={RightArrow} />
      </div>
    </div>
  )
}

const RightArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
  <path d="M12.707 0.292893C12.3165 -0.0976311 11.6835 -0.0976306 11.293 0.292893C10.9024 0.683416 10.9024 1.31643 11.293 1.70696L16.582 6.99602H1L0.897461 7.0009C0.393324 7.05223 0 7.47834 0 7.99602C0 8.5137 0.393324 8.93981 0.897461 8.99113L1 8.99602H16.5898L11.293 14.2929L11.2246 14.3691C10.9043 14.7618 10.9269 15.3408 11.293 15.707C11.6591 16.0731 12.2381 16.0957 12.6309 15.7753L12.707 15.707L19.707 8.70695C19.8946 8.51942 20 8.26513 20 7.99992C20 7.96684 19.9984 7.93393 19.9951 7.90129V7.89348C19.9692 7.63914 19.8472 7.41354 19.667 7.25188L12.707 0.292893Z" fill="white"/>
</svg>`

// const FtuxAnimationWrapper = () => {
//   return <div className='flex flex-col gap-4 px-5 pb-10 items-center text-white animate-fade-750'>
//         <motion.div
//           initial={{ y: 50, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           transition={{ type: 'spring', stiffness: 300, damping: 25 }}
//           className='w-full'
//         >
//           <FTUXInvestNow ScreenName={''} screenType={''} />
//         </motion.div>
//       </div>
// }
